const base = require('./base')
const qcwyAPI = {
  videoInfo: base.base.PHPPath+'qcwy/front.video/videoDetail',                   //视频详情
  thumbUp: base.base.PHPPath+'qcwy/front.video/videoThumb',                      //视频点赞
  isThumbUp: base.base.PHPPath+'qcwy/front.video/isThumbUp',                     //判断当前用户是否点赞
  addReadRecord: base.base.PHPPath+'qcwy/front.video/addReadRecord',             //增加阅读记录
  addShareRecord: base.base.PHPPath+'qcwy/front.video/addShareRecord',             //增加阅读记录
  addScanTimes: base.base.PHPPath+'qcwy/front.promotion/recordTimes',            //记录扫码次数
}
module.exports={
  qcwyAPI:qcwyAPI,
}


// WEBPACK FOOTER //
// ./src/api/qcwy.js